import axios from '../configs/axios';
import { serializeQuery } from '../utility/helpers/serializeQuery';

class LrsContactRepository {
    async getLrsContactById(contactId) {
        const response = await axios.get(`lrs-contact/${contactId}`);
        return response;
    }

    async getLrsContactsByLawyer(lawyerId, payload) {
        const response = await axios.get(
            `lrs-contact/by_lawyer/${lawyerId}?${serializeQuery(payload)}`,
        );
        return response;
    }

    async updateLrsContact(userId, payload) {
        const response = await axios.put(`lrs-contact/${userId}`, payload);
        return response;
    }
}

export default new LrsContactRepository();
